import registerGlobalComponentsListener from './RegisterGlobalComponentsListener'
import interceptadorHttp from './InterceptadorHttp'
import buscarProdutoListener from '@/application/listeners/BuscarProdutoListener'

export default {
    buscarProdutoListener,
    registerGlobalComponentsListener,
    interceptadorHttp
}
